export default __webpack_public_path__ + "static/media/p2023-14.34596b24.jpeg";